"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFull = void 0;

var Absorbers_1 = require("./Plugins/Absorbers");

var Emitters_1 = require("./Plugins/Emitters");

var Trail_1 = require("./Interactions/External/Trail");

var PolygonMask_1 = require("./Plugins/PolygonMask");

var Roll_1 = require("./Updaters/Roll");

var slim_1 = require("./slim");

var Tilt_1 = require("./Updaters/Tilt");

var Twinkle_1 = require("./Updaters/Twinkle");

var Wobble_1 = require("./Updaters/Wobble");

function loadFull(_x) {
  return _loadFull.apply(this, arguments);
}

function _loadFull() {
  _loadFull = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, slim_1.loadSlim)(engine);

          case 2:
            _context.next = 4;
            return (0, Roll_1.loadRollUpdater)(engine);

          case 4:
            _context.next = 6;
            return (0, Tilt_1.loadTiltUpdater)(engine);

          case 6:
            _context.next = 8;
            return (0, Twinkle_1.loadTwinkleUpdater)(engine);

          case 8:
            _context.next = 10;
            return (0, Wobble_1.loadWobbleUpdater)(engine);

          case 10:
            _context.next = 12;
            return (0, Trail_1.loadExternalTrailInteraction)(engine);

          case 12:
            _context.next = 14;
            return (0, Absorbers_1.loadAbsorbersPlugin)(engine);

          case 14:
            _context.next = 16;
            return (0, Emitters_1.loadEmittersPlugin)(engine);

          case 16:
            _context.next = 18;
            return (0, PolygonMask_1.loadPolygonMaskPlugin)(engine);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadFull.apply(this, arguments);
}

exports.loadFull = loadFull;